<ng-container *ngIf="(isSwipeUpSearchBar$ | async); else searchBar">
  <app-swipe-up
    [classType]="swipeStyle"
    [height]="100"
    [title]="'TITLE_SEARCH_HOME' | transloco"
    [showHeader]="true"
    [showSwipeUp]="editSearchIsActivated$ | async"
    (toggleShowSwipeUp)="toggleSearchBar()">
    <ng-container *ngIf="editSearchIsActivated$ | async" content>
      <ng-container *ngTemplateOutlet="searchBar"></ng-container>
    </ng-container>
  </app-swipe-up>
</ng-container>

<ng-template #searchBar>
  <div class="tourAndActivitiesSearchBar__cont tourAndActivitiesSearchBar__cont--behavior-{{searchBarBehavior}}">
    <ng-container *ngIf="(isMobile$ | async) === false">
      <ng-container *ngIf="resultsPage">
        <app-ds-icon
          class="tourAndActivitiesSearchBar__action-back"
          [icon]="icons.ChevronLeft"
          [size]="28"
          [color]="iconColor.Primary"
          (click)="navigateToBack()">
        </app-ds-icon>
      </ng-container>
    </ng-container>
    <div class="tourAndActivitiesSearchBar__wrapper tourAndActivitiesSearchBar__wrapper--behavior-{{searchBarBehavior}}">
      <ng-container *ngIf="isMobile$ | async">
        <div class="tourAndActivitiesSearchBar__titles">
          <app-ds-typography
            [size]="fontSize.XXS"
            [fontFamily]="fontFamily.SemiBold"
            [color]="fontColor.Primary"
            [tag]="'h2'"
            [text]="'SEARCH_MODULE.TOUR_AND_ACTIVITIES_TITLE' | transloco">
          </app-ds-typography>
          <app-ds-typography
            [size]="fontSize.XXS"
            [fontFamily]="fontFamily.Regular"
            [color]="fontColor.Secondary"
            [tag]="'h4'"
            [text]="'SEARCH_MODULE.TOUR_AND_ACTIVITIES_SUBTITLE' | transloco">
          </app-ds-typography>
        </div>
      </ng-container>
      <div class="tourAndActivitiesSearchBar__input">
        <app-search-input-activity
          [searchType]="searchType"
          [isMobile]="isMobile$ | async"
          [icon]="icons.Location"
          [input]="input$ | async"
          [showError]="isEmptyInput$ | async"
          [countryCode]="'SEARCH_MODULE.LOCATION_SEARCH.DESTINATION' | transloco"
          [countryName]="'SEARCH_MODULE.LOCATION_SEARCH.YOUR_DESTINATION_MOBILE' | transloco"
          [autoCompletePlaces]="autoCompletePlaces$ | async"
          [autofocus]="true"
          [resultsPage]="resultsPage"
          [isLoadingAutocompletePlaces]="isLoadingAutocompletePlaces$ | async"
          (inputChanged)="placeInputChanged($event)"
          (removeAutoCompletePlaces)="clearAutocompletePlaces()"
          (locationNotFoundEvent)="locationNotFoundEvent($event)"
          (popularSelected)="popularSelectedEvent($event)"
          (selectInput)="selectPlace($event)">
        </app-search-input-activity>
      </div>
      <div class="tourAndActivitiesSearchBar__card" *ngIf="isMobile$ | async">
        <app-activities-ad-banner></app-activities-ad-banner>
      </div>
    </div>
    <div class="tourAndActivitiesSearchBar__searchBtn">
      <ng-container *ngIf="isMobile$ | async; else searchBtn">
        <app-fixed-surface [boxShadow]="true">
          <ng-container *ngTemplateOutlet="searchBtn; context: { hiddenIcon: true }"></ng-container>
        </app-fixed-surface>
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #searchBtn let-hiddenIcon="hiddenIcon">
  <app-ds-button
    [isLoading]="searching"
    [showIcon]="!hiddenIcon"
    [icon]="icons.Search"
    [size]="buttonSize$ | async"
    [labels]="{ ButtonLabel: 'BUTTONS.SEARCH' | transloco }"
    (clickEvent)="goToResults()">
  </app-ds-button>
</ng-template>
